import React from 'react'
import DealmedImage from './img/dealmed-hero-bg-new.webp'
import './content.scss'

// export default function EmeraldHomeBannerSection({ data }) {
export default function EmeraldHomeBannerSection() {
  const data = {
    header: 'A fast, smart medical supply partner you can lean on',
    subheader:
      'Our agility, knowledge, and global reach keep your business a step ahead of whatever comes next.',
    buttonText: 'SHOP NOW',
    buttonLink: '/shop',
    backgroundImage: '',
  }

  const { header, subheader, buttonText, buttonLink, backgroundImage } = data
  return (
    <div className="afsm">
      <div
        className="afsm__image"
        style={{ backgroundImage: `url(${DealmedImage})` }}
        // style={{backgroundImage:`url(${backgroundImage.fields.file.url})`}}
      >
        <div className="afsm__block">
          <div className="afsm__left">
            <h1 className="afsm__title white">{header}</h1>

            <p className="afsm__desc">{subheader}</p>

            <a href={buttonLink} className="afsm__btn-shopnow">
              {buttonText}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
